module.exports = __webpack_public_path__ + "static/mark_2-371d42e90b219de1cc50841ae754b4bb.png";